export abstract class ExtensionBase extends Autodesk.Viewing.Extension {

    static registerExtension(extensionName: string, extension: Object) {
        Autodesk.Viewing.theExtensionManager.registerExtension(extensionName, extension);
    }

    static unregisterExtension(extensionName: string) {
        Autodesk.Viewing.theExtensionManager.unregisterExtension(extensionName);
    }

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options?: any) {
        super(viewer, options);
    }

    load(): boolean {
        this.viewer.addEventListener(
            Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT,
            this.onModelRootLoaded);
        this.viewer.addEventListener(
            Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
            this.onGeometryLoaded);
        this.viewer.addEventListener(
            Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT,
            this.onObjectTreeCreated);

        return true;
    }

    unload(): boolean {
        this.viewer.removeEventListener(Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT, this.onModelRootLoaded);
        this.viewer.removeEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, this.onGeometryLoaded);
        return true;
    }

    protected getControlGroup(groupId: string): Autodesk.Viewing.UI.ControlGroup {
        const toolbar = this.viewer.getToolbar(false);
        const group = toolbar.getControl(groupId) as Autodesk.Viewing.UI.ControlGroup;
        if (group == null) {
            const control = new Autodesk.Viewing.UI.ControlGroup(groupId);
            toolbar.addControl(control);
            return control;
        } else {
            return group;
        }
    }

    protected onModelRootLoaded(): void {
    }

    protected onGeometryLoaded(): void {
    }

    protected onObjectTreeCreated(): void {
    }
}

